import * as React from "react"
import { LocaleProvider } from "./context"

const wrapPageElement = ({ element, props }) => (
  <LocaleProvider pageContext={props.pageContext}>{element}</LocaleProvider>
)

export { wrapPageElement }
